import styled from "styled-components";
import { Button as MuiButton } from "@mui/material";

export const ButtonStyled = styled(MuiButton)`
  display: flex;
  gap: 5px;
  height: 36px;
  font-size: 12px !important;
  font-weight: 500;
  box-shadow: none;
  border: 1px solid transparent;
  text-transform: none;
  line-height: 24px;
  letter-spacing: -0.12px;
  font-family: Inter !important;
  padding: 6px 8px !important;
  min-width: 31px !important;
  box-shadow: none !important;
  :hover {
    box-shadow: none;
  }

  .MuiButton-startIcon {
    margin: unset;
  }

  .MuiButton-endIcon {
    margin: unset;
  }
`;
